import { IAutoMapper } from "../../../../../../core/automapper/interfaces";
import { StringHelper } from "../../../../../../utilities/contracts/string-helper";

const OVERREADER2_ROLE_NAME = "Overreader2";

export const mapOverreadFeedbackQueryItem = (automapper: IAutoMapper): void => {
  automapper.createMap("default", "OverreadFeedbackQueryItem")
    .forMember("chaseId", o => o.chaseId)
    .forMember("measureCode", o => o.measureCode)
    .forMember("codingUserId", o => o.codingUserId)
    .forMember("codingUserName", o => o.codingUserName)
    .forMember("codingDate", o => o.codingDate)
    .forMember("qaUserId", o => o.qaUserId)
    .forMember("qaUserName", o => o.qaUserName)
    .forMember("qaDate", o => o.qaDate)
    .forMember("qaRoleName", o => o.qaRoleName)
    // OR2 only reviews OR1, so on an OR2 row the coding date is OR1's and the MRR date is not returned.
    .forMember("mrrDate", o => o.qaRoleName === OVERREADER2_ROLE_NAME ? null : o.codingDate)
    .forMember("overreadDate", o => o.qaRoleName === OVERREADER2_ROLE_NAME ? o.codingDate : o.qaDate)
    .forMember("overread2Date", o => o.qaRoleName === OVERREADER2_ROLE_NAME ? o.qaDate : null)
    .forMember("errorCount", o => o.errorCount)
    .forMember("errorReviewCompletedCount", o => o.errorReviewCompletedCount)
    .forMember("errorReviewToBeCompletedCount", o => o.errorReviewToBeCompletedCount)
    .forMember("codingReceiptStatus", o => o.codingReceiptStatus)
    .forMember("qaReceiptStatus", o => o.qaReceiptStatus)
    .forMember("chaseOverreadFeedbackStatus", o => o.chaseOverreadFeedbackStatus)
    .forMember("recordCount", o => o.recordCount)
    .forMember("codingReviewMode", o => o.codingReviewMode);
};

export class OverreadFeedbackQueryItem {
  chaseId: number;
  measureCode: string;
  codingUserId: number;
  codingUserName: string;
  codingDate: Date;
  qaUserId: number;
  qaUserName: string;
  qaDate: Date;
  qaRoleName: string;
  mrrDate: Date;
  overreadDate: Date;
  overread2Date: Date;
  managerUserId: number;
  managerUserName: string;
  errorCount: number;
  errorReviewCompletedCount: number;
  errorReviewToBeCompletedCount: number;
  codingReceiptStatus: string;
  qaReceiptStatus: string;
  chaseOverreadFeedbackStatus: string;
  recordCount: number;
  codingReviewMode: string;
  constructor(options: Partial<OverreadFeedbackQueryItem>) {
    this.chaseId = options.chaseId;
    this.measureCode = StringHelper.clean(options.measureCode);
    this.codingUserId = options.codingUserId;
    this.codingUserName = StringHelper.clean(options.codingUserName);
    this.codingDate = options.codingDate;
    this.qaUserId = options.qaUserId;
    this.qaUserName = StringHelper.clean(options.qaUserName);
    this.qaDate = options.qaDate;
    this.qaRoleName = StringHelper.clean(options.qaRoleName);
    this.mrrDate = options.mrrDate;
    this.overreadDate = options.overreadDate;
    this.overread2Date = options.overread2Date;
    this.managerUserId = options.managerUserId;
    this.managerUserName = StringHelper.clean(options.managerUserName);
    this.errorCount = options.errorCount;
    this.errorReviewCompletedCount = options.errorReviewCompletedCount;
    this.errorReviewToBeCompletedCount = options.errorReviewToBeCompletedCount;
    this.codingReceiptStatus = StringHelper.clean(options.codingReceiptStatus);
    this.qaReceiptStatus = StringHelper.clean(options.qaReceiptStatus);
    this.chaseOverreadFeedbackStatus = StringHelper.clean(options.chaseOverreadFeedbackStatus);
    this.recordCount = options.recordCount;
    this.codingReviewMode = options.codingReviewMode;
  }
}
